import React, { useState, useContext } from 'react';
import LoadingContext from '../context/loading.context';
import UserDetailsContext from '../context/userDetails.context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from './Spinner.component';
import * as Constants from '../modules/constants';

function ChangePasswordDialog(props) {

    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { token } = useContext(UserDetailsContext);

    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [buttonsEnabled, setButtonsEnabled] = useState(true);

    const confirmNewPasswordRef = React.createRef();

    const apiHostName = Constants.API_URL;

    function clearFields() {
        setPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
        setValidated(false);
        setButtonsEnabled(true);
    }

    function showMessage(message) {
        alert(message);
    }

    function handleSubmit(event) {

        event.preventDefault();

        // Check form validation
        const form = event.currentTarget;
        setButtonsEnabled(false);
        //setRegisterError('');
        setValidated(true);

        confirmNewPasswordRef.current.setCustomValidity(newPassword === confirmNewPassword ? '' : "Passwords don't match.");

        if (form.checkValidity() === false) {
            // Invalid form, so stop processing
            event.stopPropagation();
            setButtonsEnabled(true);
            return;
        }

        // Ask server to change the password:
        showLoading();
        fetch(apiHostName + '/v1/users/changePassword', {
            mode: "cors",
            method: 'PUT',
            cache: "no-cache",
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ currentPassword: password, newPassword: newPassword })
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network error');
                }
                return response.text();
            })
            .then((result) => {
                // Result contains "Ok"
                // Note: we don't need to update the user token...
                clearFields();
                hideLoading();
                props.onHide();
                showMessage('Your password has been changed.');
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on registration screen
                console.error("Cannot change password...");
                console.error(error);
                showMessage('Password cannot be changed.');
                hideLoading();
                setButtonsEnabled(true);
            });

    }

    function setNewPasswordText(value) {
        setNewPassword(value);
        confirmNewPasswordRef.current.setCustomValidity(value === confirmNewPassword ? '' : "Passwords don't match.");
    }
    function setConfirmNewPasswordText(value) {
        setConfirmNewPassword(value);
        confirmNewPasswordRef.current.setCustomValidity(value === newPassword ? '' : "Passwords don't match.");
    }

    return (
        <Modal show={props.show} onShow={clearFields} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Change your password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={(event) => { handleSubmit(event); }}>
                    <Form.Group controlId="formPassword">
                        <InputGroup>
                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                            <Form.Control type="password" name="CurrentPassword" placeholder="Current password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=.*\d).{6,}$" value={password} onChange={(e) => { setPassword(e.target.value); }} required />
                            <Form.Control.Feedback type="invalid">
                                <div className="control-feedback">Please fill your current password</div>
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group controlId="formNewPassword">
                        <InputGroup>
                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                            <Form.Control type="password" name="NewPassword" placeholder="New password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?=.*\d).{6,}$" value={newPassword} onChange={(e) => { setNewPasswordText(e.target.value); }} required />
                            <Form.Control.Feedback type="invalid">
                                <div className="control-feedback">Please fill a new password (at least 6 long, with upper- and lowercase, digit and non-alphanumeric character).</div>
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group controlId="formConfirmPassword">
                        <InputGroup>
                            <span className="input-group-text"><FontAwesomeIcon icon="key" /></span>
                            <Form.Control type="password" name="ConfirmPassword" placeholder="Confirm new password" value={confirmNewPassword} ref={confirmNewPasswordRef} onChange={(e) => { setConfirmNewPasswordText(e.target.value); }} />
                            <Form.Control.Feedback type="invalid">
                                <div className="control-feedback">Please confirm your password.</div>
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group style={{ justifyContent: 'flex-end' }}>
                        <Button type="submit" disabled={!buttonsEnabled} style={{ marginRight: '5px' }}>Change password <Spinner /></Button>
                        <Button disabled={!buttonsEnabled} onClick={props.onHide}>Cancel</Button>
                    </Form.Group>
                </Form>


            </Modal.Body >
        </Modal >
    );
}

export default ChangePasswordDialog;


// WEBPACK FOOTER //
// ./src/components/ChangePasswordDialog.js